import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';

// import { useAuth } from 'features/auth';
// import { EventsProps } from '../types';

// const { REACT_APP_ENVIRONMENT } = process.env;

// const devMode = REACT_APP_ENVIRONMENT === 'development';

const useGTM = (trackingId: string | null) => {
  // const location = useLocation();
  const [, setInitialized] = useState(false);

  //   const { studentUuid } = useAuth();

  // const gtmEventTrack = useCallback(
  //   ({ eventName, ...props }: EventsProps) => {
  //     if (initialized) {
  //       eventGTM(eventName as string, props);
  //     }
  //   },
  //   [initialized, location]
  // );

  // const gtmPageviewTrack = useCallback(
  //   (path: string) => {
  //     if (initialized) {
  //       eventGTM('page_view', { location: path });
  //     }
  //   },
  //   [initialized, trackingId]
  // );

  useEffect(() => {
    if (trackingId) {
      TagManager.initialize({
        gtmId: trackingId,
      });

      setInitialized(true);
    }
  }, [trackingId]);

  // useEffect(() => {
  //   if (initialized) {
  //     gtmPageviewTrack(location.pathname + location.search);
  //   }
  // }, [initialized, location, trackingId]);

  //   useEffect(() => {
  //     if (initialized && studentUuid) {
  //       ReactGA.set(
  //         { userId: studentUuid },
  //         trackingId.map((_, gtmIndex) => `tracker${gtmIndex}`)
  //       );
  //     }
  //   }, [studentUuid, trackingId]);

  return TagManager;
};

export default useGTM;
